import { render } from "./DestinationCardComponent.vue?vue&type=template&id=fca7fa2a"
import script from "./DestinationCardComponent.vue?vue&type=script&lang=js"
export * from "./DestinationCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__